




import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component
export default class MyButton extends Vue {
  @Prop() public greet?: string;
  @Emit() public click() {
    // Clicked Button Callback
  }

  public onClick() {
    alert(this.greet);
    this.click();
  }
}
